// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-right {\n  margin-right: 6px;\n}\n.margin-top-16 {\n  margin-top: 16px;\n}\n.margin-left-8 {\n  margin-left: 8px;\n}\n.margin-top-8 {\n  margin-top: 8px;\n}\n.icon-delete {\n  color: red;\n}\n", ""]);
// Exports
module.exports = exports;
